import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { initObservability } from "./lib/observability";
import "./index.css";

initObservability();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary scope="root">
    <App />
  </ErrorBoundary>,
);
